/**
 * Fake the progress bar while fetching recommendation
 */
export const fakeProgressHack = (setProgressFunction, durationMs, step = 5) => {
  let value = 0;
  let letPromiseId = 0;
  let fakeProgressId = 0;
  let stepHalfed = step / 2;
  let tickSize = durationMs / (100 / step);
  setProgressFunction(value);
  const fakeProgress = () => {
    if (value < 100 - step * 2) {
      value += (Math.random() * stepHalfed + stepHalfed) >> 0;
      setProgressFunction(value);
      fakeProgressId = setTimeout(
        fakeProgress,
        Math.random() * tickSize * 0.75 + tickSize * 0.25
      );
    }
  };
  fakeProgress();

  let promiseResolver;
  return [
    /**
     * Promise which resolves after durationMs
     */
    new Promise(resolve => {
      promiseResolver = resolve;
      letPromiseId = setTimeout(() => resolve(), durationMs);
    }),
    /**
     * Manually stop the fake progress, immediately resolves promise
     */
    () => {
      clearTimeout(fakeProgressId);
      clearTimeout(letPromiseId);
      promiseResolver();
    }
  ];
};
